import React from 'react';

import { Container, Row } from 'react-bootstrap';
import { withAuthorization } from '../Session';

import AllList from './AllList';

class StoreTagMapping extends React.Component {
    state = {};
    render() {
        return (
            <Container>
                <AllList {...this.props} />
            </Container>
        );
    }
}
const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(StoreTagMapping);
